<template>
  <material-card
    style="margin-top:30px"
    scrollable
    :title="$t('components.plancreationwizard.broker_contact_info_for_reports')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="email"
  >
    <v-form :disabled="disabled">
      <v-col cols="12">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-row no-gutters>
              <v-col>
                <v-checkbox
                  style="display:inline-block"
                  v-model="reportConfiguration.InheritedBrokerAddress"
                  :label="
                    $t(
                      'components.plancreationwizard.display_current_brokers_address_logo_in_reports'
                    )
                  "
                ></v-checkbox>
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  style="margin-bottom:20px;margin-left:3px;display:inline-block"
                >
                  help
                </v-icon>
              </v-col>
            </v-row>
          </template>
          <span>
            {{
              $t(
                "components.plancreationwizard.display_current_brokers_address_tooltip"
              )
            }}
          </span>
        </v-tooltip>
      </v-col>
      <template v-if="!reportConfiguration.InheritedBrokerAddress">
        <address-form
          ref="reportAddress"
          :provinces="options.Models.Province"
          :item="address"
          @valid="$emit('valid', $event)"
          :alwaysDirty="true"
        ></address-form>
        <v-col xs="12" sm="6" md="4" lg="3">
          <image-uploader-string
            @image-data="
              reportConfiguration.BrokerLogo = $event;
              $forceUpdate();
            "
            :image="reportConfiguration.BrokerLogo"
            :rules="[$rules.required]"
            class="required"
            :label="$t('globals.logo')"
          ></image-uploader-string>
        </v-col>
      </template>
    </v-form>
  </material-card>
</template>
<script>
import { mapGetters } from "vuex";
import ImageUploaderString from "@/components/ImageUploaderString";
import AddressForm from "@/components/AddressForm";

export default {
  components: { ImageUploaderString, AddressForm },
  props: ["reportConfiguration", "reportConfigurationAddress", "disabled"],
  computed: {
    ...mapGetters("plansMembers", ["options"]),
  },
  data() {
    return {
      address: null,
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    reportConfiguration: {
      handler() {
        this.init();
      },
      immediate: true,
    },
    "reportConfiguration.InheritedBrokerAddress": {
      handler(v) {
        this.$emit("update-address", { Address: {} });
        if (v) {
          this.$emit("valid", true);
          this.reportConfiguration.BrokerLogo = null;
        } else {
          this.$emit("valid", false);
        }
      },
      immediate: true,
    },
    reportConfigurationAddress: {
      handler(v) {
        this.address = v;
      },
      immediate: true,
    },
    address: {
      handler(v) {
        this.$emit("update-address", v);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    init() {
      if (this.reportConfiguration) {
        if (this.reportConfiguration.InheritedBrokerAddress) {
          this.address = {
            Address: {},
          };
        } else {
          this.address = {
            Address: {
              City: this.reportConfiguration.BrokerCity,
              PostalCode: this.reportConfiguration.BrokerPostalCode,
              Province: this.options.Models.Province.filter(
                (o) => o.Name === this.reportConfiguration.BrokerProvince
              )[0],
              StreetName: this.reportConfiguration.BrokerStreetName,
              StreetNumber: this.reportConfiguration.BrokerStreetNumber,
              SuiteNumber: this.reportConfiguration.BrokerSuiteNumber,
            },
          };
        }
      }
    },
  },
};
</script>
